import Axios from "axios";
import Url from "app/shared/constants/Url";
import {
  SuccessToast,
  ErrorToast,
} from "app/shared/components/Popups/ToastMessage";
import { convertDateFromTimezone } from "app/shared/utility/tzUtilFunction";

const Exportcsv = async (_setDataLoading) => {
  SuccessToast(
    "Exporting of NM is in progress, please wait and do not perform any operation"
  );
  let URL = Url.nmModule.nmExport;
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");

  let data;
  data = new FormData();

  data.append("auth_key", token);
  data.append("user_id", userId);

  var paramData = {
    auth_key: token,
    user_id: userId,
    // startDate: '2023-11-18',
    //     endDate: '2024-11-26',
    //     projectId: [45, 46],
  };

  try {
    const response = await Axios.post(`${URL}`, data, {
      params: paramData,
      responseType: "blob", // Important for downloading Excel files
    });
    console.log(response, "response");

    // Create a link to download the file
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download",
      "nm_export_" + convertDateFromTimezone(new Date()) + `.xlsx`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    SuccessToast("Exported successfully");
    _setDataLoading(false);
  } catch (error) {
    console.error("CSV Export Failed", error);
    ErrorToast("Failed to export CSV");
  }
};

export default Exportcsv;
